import { render } from "./DeclareFormatCheck.vue?vue&type=template&id=07daea44"
import script from "./DeclareFormatCheck.vue?vue&type=script&lang=js"
export * from "./DeclareFormatCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__